import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function CircleHelpIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M12 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-10c2.24 0 4 1.646 4 4 0 1.22-.52 2.108-1.229 2.79-.657.632-1.53 1.128-2.254 1.566a1.001 1.001 0 1 1-1.034-1.711c.82-.495 1.447-.858 1.903-1.296.404-.39.614-.784.614-1.349 0-1.215-.83-2-2-2-.933 0-1.69.477-1.997 1.177l-.056.143a1 1 0 0 1-1.894-.64l.122-.316C8.846 6.834 10.412 6 12 6" />
        <path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18" />
      </>
    </Icon>
  );
}

CircleHelpIcon.displayName = 'CircleHelpIcon';
